import {Filter} from '../core/filter/filter';

export class ClientFilter extends Filter {
  public text?: string;
}
